/* eslint-disable react/jsx-props-no-spreading */
import { useForm } from '@folklore/forms';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { useApi } from '../../contexts/ApiContext';
import { useUser } from '../../contexts/AuthContext';
import { useUrlGenerator } from '../../contexts/RoutesContext';
import Checkbox from '../fields/Checkbox';

import styles from '../../../styles/forms/newsletter.module.scss';

const propTypes = {
    onComplete: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    onComplete: null,
    className: null,
};

const NewsletterForm = ({ onComplete, className }) => {
    const route = useUrlGenerator();

    const api = useApi();
    const user = useUser();
    const { id: userId = null, name, email, password, newsletter = false } = user || {};

    const update = useCallback(
        (action, data) => api.account.update({ ...data, userId }),
        [api, userId],
    );
    const { fields, onSubmit, submit, value, setValue } = useForm({
        postForm: update,
        fields: ['newsletter'],
        value: user,
        ...(onComplete !== null ? { onComplete } : { onComplete: () => {} }),
    });

    const onNewsletterChange = useCallback(
        (val) => {
            const { onChange } = fields.newsletter;
            onChange(val);
        },
        [fields.newsletter, onSubmit],
    );

    // Updates user if it changes because parallel forms
    useEffect(() => {
        setValue(user);
    }, [name, email, password]);

    // Submit on change
    useEffect(() => {
        submit();
    }, [submit, value]);

    return (
        <form
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            action={route('account.update')}
            onSubmit={onSubmit}
        >
            <Checkbox
                {...fields.newsletter}
                onChange={onNewsletterChange}
                label={
                    newsletter !== true ? (
                        <FormattedMessage
                            defaultMessage="Subscribe to the newsletter"
                            description="Button label"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="You are subscribed to the newsletter"
                            description="Button label"
                        />
                    )
                }
            />
        </form>
    );
};
NewsletterForm.propTypes = propTypes;
NewsletterForm.defaultProps = defaultProps;

export default NewsletterForm;
